import { render, staticRenderFns } from "./ImpactQmsRequirementEdit.vue?vue&type=template&id=65b2f10f&scoped=true&"
import script from "./ImpactQmsRequirementEdit.vue?vue&type=script&lang=ts&"
export * from "./ImpactQmsRequirementEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b2f10f",
  null
  
)

export default component.exports